import React from 'react';
import { useVariantEdit } from '../VariantEditContext';
import { useVariants } from '../VariantsContext';
import Button from '@dashboard/components/Button';
import Reorderable from '@dashboard/components/Reorderable';
import VariantItem from './VariantItem';

export default function VariantsList() {
  const { state: variants } = useVariants();
  const { isAddingVariant, onReorderVariants, onAddVariant } = useVariantEdit();

  return (
    <div>
      {variants.length > 0 && (
        <div className="mb-8">
          <Reorderable.Wrapper>
            <Reorderable
              id="variants"
              items={variants}
              onReorder={onReorderVariants}
              renderItem={({ item: variant, dragHandleProps, isDragging }) => (
                <Reorderable.Item isDragging={isDragging}>
                  <VariantItem variant={variant} dragHandleProps={dragHandleProps} />
                </Reorderable.Item>
              )}
            />
          </Reorderable.Wrapper>
        </div>
      )}

      {!isAddingVariant && (
        <div className="flex">
          <Button handleClick={onAddVariant} appearance="primary">
            + Add variant
          </Button>
        </div>
      )}
    </div>
  );
}
